export default __webpack_public_path__ + "static/media/downlaodIcon.52be1457.svg";